/**
 * @generated SignedSource<<a8de52b7cd5c3796e73a8b9c3b854cda>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type StoreFlag = "Calendar" | "CustomerFeedback" | "EmployeeRole" | "GroupAccountsAndProfiles" | "MigratedTeamSchedule" | "OnbardedTeams" | "Product" | "ProductDateTracker" | "SignalWidget" | "TodoAsIssue" | "TodoNewTimlineAndComments" | "VersionSummer24";
import { FragmentRefs } from "relay-runtime";
export type useHasFeatureFlag_store$data = {
  readonly flags: ReadonlyArray<StoreFlag>;
  readonly id: string;
  readonly " $fragmentType": "useHasFeatureFlag_store";
};
export type useHasFeatureFlag_store$key = {
  readonly " $data"?: useHasFeatureFlag_store$data;
  readonly " $fragmentSpreads": FragmentRefs<"useHasFeatureFlag_store">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useHasFeatureFlag_store",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "flags",
      "storageKey": null
    }
  ],
  "type": "Store",
  "abstractKey": null
};

(node as any).hash = "4cc43669683fe549632c9dbc8b370b93";

export default node;
